import $ from 'jquery';
import _ from 'underscore';

"use strict";

var ViewLogin = Backbone.View.extend({

    recoverPassword: '#RecoverPassword',
    recoverPasswordForm: '#RecoverPasswordForm',
    hideRecoverPasswordLink: '#HideRecoverPassword',
    customerLoginForm: '#CustomerLoginForm',
    resetSuccess: '#ResetSuccess',
    resetSuccessMessage: '.reset-password-success',
    recoverHash: '#recover',

    initialize: function (opts) {
        var self = this;
        self.$content = self.$el;
        self.theBody = $('body');

        // var hash = window.location.hash.replace(/\?.+/, '');
        // if (hash === '#recover') $('#CustomerLoginForm, #RecoverPasswordForm, #LoginRegisterNavi').toggleClass('hide');

        // register page
        self.birthdayInputValidation();

        self.formInit();
    },
    
    events: {
        'click #RecoverPassword, #HideRecoverPassword': function (e) {
            // $('#CustomerLoginForm, #RecoverPasswordForm, #LoginRegisterNavi').toggleClass('hide');
        }
    },

    formInit: function(){

        // The contents of this form js are taken from /src/scripts/templates/customers-login.js
        // It has been refactored to fit within the onerockwell js framework.
        var self = this;
    
        if (!$(self.recoverPassword).length) {
            return;
        }

        self.checkUrlHash();
        self.resetPasswordSuccess();

        var events = {
            'click #RecoverPassword' : function(e){
                self.onShowHidePasswordForm(e);
            },
            'click #HideRecoverPassword' : function(e){
                self.onShowHidePasswordForm(e);
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    birthdayInputValidation: function(){
        var self = this;

        var birthdayInput = $('form input[data-type="date"]');
        birthdayInput.val('');
        
        birthdayInput.on('input', function () {
            if (/^(\d){3}$/.test(this.value) || /^(\d){2}\/(\d){3}/.test(this.value)) {
            $(this).val(this.value.replace(/\d$/, '/$&'));
            } else if (
            /^\d$/.test(this.value) ||
            /^(\d){2}$/.test(this.value) ||
            /^(\d){2}\/$/.test(this.value) ||
            /^(\d){2}\/\d$/.test(this.value) ||
            /^(\d){2}\/(\d){2}$/.test(this.value) ||
            /^(\d\d\/){2}$/.test(this.value) ||
            /^(\d\d\/){2}\d$/.test(this.value) ||
            /^(\d\d\/){2}(\d){2}$/.test(this.value) ||
            /^(\d\d\/){2}(\d){3}$/.test(this.value) ||
            /^(\d\d\/){2}(\d){4}$/.test(this.value)
            ) {
            return;
            } else {
            $(this).val(this.value.slice(0, -1));
            }
        });

    },

    onShowHidePasswordForm: function(e) {
        var self = this;
        e.preventDefault();
        self.toggleRecoverPasswordForm();
    },

    toggleRecoverPasswordForm: function(){
        /**
        *  Show/Hide recover password form
        */
        var self = this;
        $(self.recoverPasswordForm).toggleClass('hide');
        $(self.customerLoginForm).toggleClass('hide');
    },

    checkUrlHash: function() {
        var self = this;
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === self.recoverHash) {
            self.toggleRecoverPasswordForm();
        }
    },

    resetPasswordSuccess: function(){
        /**
        *  Show reset password success message
        */
        var self = this;
        var $formState = $(self.resetSuccessMessage);

        // check if reset password form was successfully submited.
        if (!$formState.length) {
        return;
        }

        // show success message
        $(self.resetSuccess).removeClass('hide');
    }
    
});

export default ViewLogin;